import { render, staticRenderFns } from "./JobDetailInfo.vue?vue&type=template&id=8955e5da"
import script from "./JobDetailInfo.vue?vue&type=script&lang=js"
export * from "./JobDetailInfo.vue?vue&type=script&lang=js"
import style0 from "./JobDetailInfo.vue?vue&type=style&index=0&id=8955e5da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports